/* featured-collection.js
   Center nav on desktop + mobile, keep slider (no 2-row wrap)
*/
if (!customElements.get('featured-collection')) {
  customElements.define(
    'featured-collection',
    class FeaturedCollection extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          sliderWrapper: '.featured-collection__items',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          pagination: '.swiper-pagination',
          controls: '.swiper-controls, .swiper-controls--grouped, .swiper-controls--pagination-progressbar',
        };
        this.classes = { swiper: 'swiper', swiperWrapper: 'swiper-wrapper' };
        this.sliderInstance = false;
      }

      connectedCallback() {
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
        if (!this.sliderWrapper) return;

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.init.bind(this);
        this.init();
      }

      init() {
        if (!this.sliderWrapper) return;

        // Always run as a slider on both desktop + mobile
        this.initSlider();

        // Keep their existing offset logic if the theme uses it
        this.calcNavButtonsPosition();
        window.addEventListener('resize', this.calcNavButtonsPosition.bind(this));
      }

      initSlider() {
        if (this.sliderInstance && typeof this.sliderInstance === 'object') return;

        const nextEl = this.querySelector(this.selectors.nextEl);
        const prevEl = this.querySelector(this.selectors.prevEl);
        const paginationEl = this.querySelector(this.selectors.pagination);

        // Force swiper structure styling so it cannot wrap into 2 rows
        this.sliderWrapper.classList.add(this.classes.swiper);
        const wrapper = this.sliderWrapper.querySelector(`.${this.classes.swiperWrapper}`);
        if (wrapper) this.forceNoWrap(wrapper);

        // Force nav visible on mobile and centered
        this.forceControlsCentered();

        this.sliderOptions = {
          slidesPerView: 2,
          spaceBetween: 10,
          loop: false,
          threshold: 2,
          navigation: {
            nextEl,
            prevEl,
          },
          pagination: paginationEl
            ? {
                el: paginationEl,
                type: 'progressbar',
                clickable: false,
              }
            : false,
          breakpoints: {
            768: { slidesPerView: 4, spaceBetween: 20 },
            1024: { slidesPerView: 5, spaceBetween: 20 },
          },
        };

        this.sliderInstance = new window.FoxTheme.Carousel(this.sliderWrapper, this.sliderOptions);
        this.sliderInstance.init();
      }

      forceNoWrap(wrapperEl) {
        wrapperEl.style.display = 'flex';
        wrapperEl.style.flexWrap = 'nowrap';
        wrapperEl.style.alignItems = 'stretch';
      }

      forceControlsCentered() {
        const controls =
          this.querySelector(this.selectors.controls) ||
          this.querySelector('.swiper-controls--grouped') ||
          this.querySelector('.swiper-controls--pagination-progressbar');

        if (!controls) return;

        // Unhide on mobile even if it has "hidden md:flex"
        controls.classList.remove('hidden');
        controls.style.display = 'flex';
        controls.style.justifyContent = 'center';
        controls.style.alignItems = 'center';
        controls.style.gap = '16px';

        const prev = controls.querySelector('.swiper-button-prev');
        const next = controls.querySelector('.swiper-button-next');
        if (prev) prev.style.display = 'flex';
        if (next) next.style.display = 'flex';
      }

      calcNavButtonsPosition() {
        const controls =
          this.querySelector(this.selectors.controls) ||
          this.querySelector('.swiper-controls--grouped') ||
          this.querySelector('.swiper-controls--pagination-progressbar');

        if (!controls) return;

        const imageWrapper = this.querySelector('.product-card__image-wrapper');
        if (!imageWrapper) return;

        const rect = imageWrapper.getBoundingClientRect();
        const offsetTop = rect.top + rect.height / 2;
        controls.style.setProperty('--swiper-nav-offset-top', `${offsetTop}px`);
      }
    }
  );
}